import styled from 'styled-components';
import { Card } from 'antd';

export const Container = styled.div`
  padding: 24px 6%;
  background-color: #f5f5f5;
  min-height: 100vh;
`;

export const ShowcaseSection = styled.div`
  margin-top: 24px;
`;

export const ComponentCard = styled(Card)`
  margin-bottom: 32px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;
